<template>
  <div class="navBar flex">
    <div class="cube flex" v-for="(item, index) in listBat" :key="index">
      <div class="circle_one">
        <img :src="item.pic" />
      </div>
      <div>
        <span>{{ item.name }}</span>
        <div class="valueNum">
          <span class="num">{{ item.value }}</span>
          <span class="ys">({{ item.unit }})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findIndexByName } from "@/util/index";
import { findDataBySCZHZB } from "@/api/schj";
export default {
  data() {
    return {
      navList: [],
      list: [],
      xzIndex: 0,
      listBat: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      findDataBySCZHZB().then(res => {
        if (res.data instanceof Array && res.data.length > 0) {
          const data = res.data[0];
          const item = res.item;
          let pic = "";
          this.listBat = item.map(e => {
            try {
              pic = require("images/index/nav/schj/" + e.name + ".png");
            } catch (e) {
              console.log(e);
              pic = require("images/index/nav/schj/年销售量.png");
            }
            const index = findIndexByName(e.name, item, "name");
            if (index > -1) {
              return {
                name: e.name,
                pic,
                value: data[item[index]["code"]],
                unit: item[index]["unit"] || ""
              };
            } else {
              return {
                name: e.name,
                pic: require("images/index/nav/schj/" + e.name + ".png"),
                value: "",
                unit: item[index]["unit"] || ""
              };
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.navBar
  position absolute
  color #fff
  right calc(27% - 10px)
  left calc(27% - 10px)
  z-index 1
  top 105px
  justify-content space-around
  font-size .06rem
  height .35rem

.cube
  background url('~images/index/nav/navBg.png') center no-repeat
  background-size 100% 100%
  height 100%
  justify-content center
  width 18%
  opacity .9
  // cursor pointer

.valueNum
  color $textColor
.xzBar
  background rgba(11,46,42,0.8)
  box-shadow inset 0px 0px 0.06rem #0ff
.num
  font-size .15rem

.circle_one
  position relative
  margin-right .05rem

  img
    width .25rem
    height .25rem
    vertical-align middle
</style>
